import { Div, RefString, Image, Collection } from "@tblabs/truffle";
import { GalleryItem } from "../../../Models/Description/Gallery/GalleryItem";
import { Box } from "../../../Pages/Components/Utils/Box";


export class Gallery extends Div
{
    constructor(images: Collection<GalleryItem>)
    {
        super("product__gallery-container");

        if (images.Count == 0)
        {
            this.Append("Brak zdjęć")
            return;
        }

        const previewPicture = new RefString(images.Items[0].ThumbnailUrl.value || images.Items[0].NormalizedUrl.value);
        const pictureUrl = new RefString(images.Items[0].NormalizedUrl.value);

        this.Append(
            new Box("product__gallery", [
                new Box("product__gallery-main", [
                    new Image(previewPicture)
                        .Class("w-full h-full object-contain absolute inset-0").Attribute("data-is-main", "true").Opacity(1)
                        .OnClick(() => window.open(pictureUrl.value, "_blank")),
                ]),
                new Box("product__gallery-thumbs", [
                    ...images.Items.map(x => new Image(x.MiniUrl.value || x.ThumbnailUrl.value || x.NormalizedUrl.value, x.Description.value)
                        .Class("product__gallery-thumb flex-shrink-0")
                        .OnClick(() =>
                        {
                            previewPicture.value = x.ThumbnailUrl.value || x.NormalizedUrl.value;
                            pictureUrl.value = x.NormalizedUrl.value;
                        })
                    )
                ]),
            ]),
        )
    }
}
